module.exports = __webpack_public_path__ + "assets/img/img160.2406fb0a.png";